
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacTextarea extends Vue {
  @Prop({ default: '' }) placeholer!: string;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: 6 }) rows!: number;
  @Prop({ default: false }) noPadding!: boolean;

  get placeholderInPlace () {
    return this.placeholer ?? ''
  }
}
